module.exports = __webpack_public_path__ + "static/media/tmdblogo.27b65cb4.svg";